/* @flow */

import type { LocationShape } from "react-router-dom";

import React from "react";
import { Link } from "react-router-dom";
import { Button as ButtonComponent } from "@crossroads/ui-components";

type Props = {
  children: React$Node,
  to?: string | LocationShape,
};

const Button = ({ to, children, ...props }: Props): React$Node => {
  if (to) {
    return (
      <Link to={to} style={{ textDecoration: "none", outline: "none" }}>
        <ButtonComponent {...props}>{children}</ButtonComponent>
      </Link>
    );
  }

  return <ButtonComponent {...props}>{children}</ButtonComponent>;
};

export default Button;
